































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserNotificationDto } from '@eurogast/hub-client-typescript';
import NotificationProductAttachments from '@/notifications/NotificationProductAttachments.vue';
import MatomoEvents from '@/matomo/events/MatomoEvents';
import NotificationUrlAttachment from '@/notifications/NotificationUrlAttachment.vue';

@Component({
  components: {NotificationUrlAttachment, NotificationProductAttachments }
})
export default class NotificationListItem extends Vue {
  @Prop({required: true})
  public notification: UserNotificationDto;

  @Prop({ required: false, default: false })
  public checked: boolean;

  private open = false;

  get attachmentCount() {
    const count = this.notification.attachedUrl ? 1 : 0;
    return count + (this.notification.attachedProducts ? this.notification.attachedProducts.length : 0);
  }

  get shortContent() {
    if (this.notification.content.length > 50) {
      return this.notification.content.substr(0, 50) + '...';
    }
    return this.notification.content;
  }

  public toggleOpen() {
    if (this.notification.unread) {
      this.markAsRead();
    }
    this.open = !this.open;

    if (this.open) {
      MatomoEvents.forNotifications.read.publishWithUnreadFlag(this.notification.unread);
    }
  }

  public onCheckedManuallyChanged() {
    if (this.notification.unread) {
      this.$emit('toggle-checked');
    }
  }

  public markAsRead() {
    if (this.notification.unread) {
      this.$emit('mark-read');
    }
  }
}
